module.exports = __webpack_public_path__ + "static/media/rounds_back_1_3.8885dafc.svg";